import { render, staticRenderFns } from "./Bovines.vue?vue&type=template&id=2c1afb1f"
import script from "./Bovines.vue?vue&type=script&lang=js"
export * from "./Bovines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports